module.exports = __webpack_public_path__ + "static/haylie_recruitment-ac5309c896272768b196afaa6c84f501.jpeg";